import Vue from 'vue'
import Router from 'vue-router'

import MainPage from '@/components/MainPage.vue'
import Login    from '@/components/Login.vue'
import Register from '@/components/Register.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // 把根路径重定向到 /login
    { path: '/', redirect: '/login' },

    { path: '/login',    name: 'Login',    component: Login },
    { path: '/register', name: 'Register', component: Register },

    // 改成 /home（或者 /app），并加上登录保护
    {
      path: '/home',
      name: 'MainPage',
      component: MainPage,
      meta: { requiresAuth: true }
    },

    // （可选）其它未匹配到的路由一律重定向到登录
    { path: '*', redirect: '/login' }
  ]
})
